<template>
  <span>
    <modal @close="$emit('close')">
      <h4 slot="title">{{ $t('leaveThe') }} {{ team.name }}</h4>
      <section slot="body" class="popup-section-body">
        <p class="warning">
          {{ $t('thisCannotBeUndone') }}
        </p>
        <p class="confirmation">
          {{ $t('youWillNeedToAskForInvitationAgain') }}
        </p>
        <div class="buttons">
          <button id="delete-button" class="clavo-button clavo-button-danger-primary" :class="{ inactive: leaveClicked }" @click="leave">
            {{ $t('leave') }}
          </button>
          <button id="cancel-button" class="clavo-button secondary" :class="{ inactive: leaveClicked }" @click="$emit('close')">
            {{ $t('cancel') }}
          </button>
        </div>
      </section>
    </modal>
  </span>
</template>

<script>
import Modal from '@/components/Modal'
import Constants from '@/components/Constants'
import ParseFunctions from '@/components/ParseFunctions'
import EventBus from '@/EventBus'

export default {
  components: {
    Modal,
  },
  mixins: [Constants, ParseFunctions],
  props: {
    team: Object,
  },
  data() {
    return {
      text: this.team ? this.texts().popup.deleteAccount.team : this.texts().popup.deleteAccount.user,
      email: '',
      initial: true, // don't remind user to tick terms immediately after he/she opens modal
      dummy: false,
      leaveClicked: false,
    }
  },
  methods: {
    async leave() {
      this.leaveClicked = true
      EventBus.$emit('leave-action-started')
      this.$store.commit('setShowProgressBar', true)
      let teamName = this.team.name
      let res = await this.getMyTeamMemberId(this.team.teamId)
      res = await this.leaveTeam(res.teamMemberId)

      if (res.status === 'ok') {
        EventBus.$emit('new-info-bar-msg', {
          msg: this.$t('successfullyLeftTeam', { x: teamName }),
        })
      } else {
        this.showServerError(res)
      }

      EventBus.$emit('leave-action-ended')

      this.$emit('close')
      this.$store.commit('setShowProgressBar', false)
    },
  },
}
</script>

<style lang="scss" scoped>
section {
  display: flex;
  flex-direction: column;
  margin: 10px 105px 30px 105px;
  width: 63%;
  @include respond-below(sm) {
    width: 100%;
    margin: 10px 0 30px 0;
  }

  * {
    // padding-left: 30px;
    // padding-right: 30px;
    text-align: left;
  }

  .confirmation-reminder {
    background-color: $powder-pink;
    color: $red;
    @include font-rule('averta-regular');
    font-size: 14px;
    width: 100%;
    height: 80px;

    margin-top: 0;
    margin-bottom: 24px;
    padding: 20px 30px 20px 30px;
    @include respond-below(sm) {
      margin: 0 0 24px 0;
    }    

    @include fade-in-opacity;
  }

  .confirmation {
    @include font-rule('averta-regular');
    font-size: 14px;
    margin-top: 0;
    margin-bottom: 20px;
  }

  .warning {
    @include font-rule('averta-bold');
    font-size: 16px;
    margin-bottom: 18px;
  }

  .check {
    margin: 0 auto 18px 30px;
    padding-left: 18px;
  }

  .buttons {
    display: flex;
    flex-direction: row;
    @include respond-below(xs) {
      flex-direction: column;
    }
    margin-top: 60px - 18px; // accounting for margin of the last checkbox
    button {
      width: 100%;
      padding: unset;
      text-align: center;
    }

    #delete-button {
      margin-right: 10px;
      @include respond-below(xs) {
        margin-right: 0;
        margin-bottom: 10px;
      }
    }
  }
}
</style>
